<admin-table-spanning [items]="factor.flags" [colspan]="'7'" [custom]="['inner-table']">
  <ng-template #header>
    <th scope="col" style="width: 8%" class="text-lowercase">{{'pages.lookup.single.result.alert.risk' | translate }}</th>
    <th scope="col" style="width: 16%" class="text-lowercase">{{'pages.lookup.channel' | translate }}</th>
    <th scope="col" style="width: 12%" class="text-lowercase">{{'pages.lookup.single.result.alert.list_record' | translate }}</th>
    <th scope="col" style="width: 40%" class="text-lowercase">{{'pages.lookup.single.result.alert.info' | translate }}</th>
    <th scope="col" style="width: 8%" class="text-lowercase">{{'pages.lookup.single.result.alert.hits' | translate }}</th>
<!--    <th scope="col" class="col-md-1">{{'pages.lookup.single.result.alert.worst' | translate }}</th>-->
    <th scope="col" style="width: 8%" class="text-lowercase">{{'pages.lookup.single.result.alert.best' | translate }}</th>
    <th scope="col" style="width: 8%" class="text-lowercase">{{'pages.lookup.single.result.alert.score' | translate }}</th>
  </ng-template>
  <ng-template #first let-item>
    <!--td><div class="text-uppercase"><span [ngClass]="'bg-' + riskClass(item.screening)" class="badge">{{('pages.lookup.single.result.alert_risk.' + item.screening.risk | translate)}}</span></div></td-->
    <td class="border-bottom-0"><div class="text-uppercase"><span [ngClass]="'text-' + riskClass(item.screening)" class="fw-bolder">{{('pages.lookup.single.result.alert_risk.' + item.screening.risk | translate)}}</span></div></td>
    <td class="border-bottom-0 text-dark">{{ item.screening.list!.owner }}&nbsp;/&nbsp;{{ item.screening.list!.vertical }}&nbsp;/&nbsp;{{ item.screening.list!.code }}</td>
    <td class="border-bottom-0">
      <button (click)="view($event, item.screening)" type="button" class="btn text-action-2 fw-5 fs-5 text-info p-0">
        {{item.screening.reference}}
      </button>
    </td>
    <td class="border-bottom-0 text-dark">{{ item.screening.info }}</td>
    <td class="border-bottom-0"><span class="fw-bolder">{{ item.screening.hits.length }}</span></td>
<!--    <td><span class="fw-bolder">{{ (100*item.screening.worstScore!).toFixed(1) }}&nbsp;%</span></td>-->
    <td class="border-bottom-0"><span class="fw-bolder">{{ (100*bestScore(item.screening)!).toFixed(1) }}&nbsp;%</span></td>
    <td class="border-bottom-0"><span class="fw-bolder" [ngClass]="'text-' + riskClass(item.screening)">{{item.screening.result?.toFixed(1)}}</span></td>
  </ng-template>
  <ng-template #second let-item>
    <admin-table-standard [items]="item.screening.hits" [custom]="['inner-table']">
      <ng-template #header>
        <th class="text-lowercase" style="width: 15%">list field</th>
        <th class="text-lowercase" style="width: 15%">data field</th>
        <th class="text-lowercase" style="width: 25%">list value</th>
        <th class="text-lowercase" style="width: 25%">data value</th>
        <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.threshold' | translate}}</th>
        <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.weight' | translate}}</th>
        <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.similarity' | translate}}</th>
        <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.score' | translate}}</th>
      </ng-template>
      <ng-template #first let-item>
        <td class="text-dark">{{ item.listField }}</td>
        <td class="text-dark">{{ item.dataField }}</td>
        <td class="text-dark">{{ item.listData }}</td>
        <td class="text-dark">{{ item.dataCandidate }}</td>
        <td class="threshold-label fw-bolder align-middle text-center">{{ (getNumberValue(item.threshold) * 100).toFixed(0) }} %</td>
        <td class="weight-label fw-bolder align-middle text-center">{{ getNumberValue(item.value).toFixed(2) }}</td>
        <td class="fw-bolder align-middle text-center">{{ (getNumberValue(item.score) * 100).toFixed(0) }} %</td>
        <td [ngClass]="'fw-bolder align-middle text-center'">{{ getNumberValue(item.result).toFixed(1) }}</td>
      </ng-template>
    </admin-table-standard>
  </ng-template>
</admin-table-spanning>
